import {
  Datagrid,
  DeleteButton,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  TextField,
} from "react-admin";

export function ContestWinnerList(props) {
  return (
    <List {...props}>
      <Datagrid bulkActionButtons={true}>
        <ReferenceField source="contestId" reference="contest">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="childId" reference="child">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          source="submissionId"
          reference="contestSubmission"
          label="Submission Id"
        >
          <TextField source="id" />
        </ReferenceField>
        <NumberField source="rank" />
        <DeleteButton />
      </Datagrid>
    </List>
  );
}
